export enum ServiceStatus {
  OPERATIONAL = 'operational',
  DEGRADED = 'degraded',
  DOWN = 'down',
}

export enum ServiceType {
  RESEARCH = 'research',
  SSO = 'sso',
  REPORTING = 'reporting',
  FUNDFIT = 'fundfit',
}

export enum IncidentType {
  EVENT = 'event',
  MAINTENANCE = 'maintenance',
}

export enum IncidentStatus {
  ONGOING = 'ongoing',
  RESOLVED = 'resolved',
}

// ===== Public API Types (for public status pages) =====
export interface PublicDailyServiceMetrics {
  date: string;
  status: ServiceStatus;
}

export interface PublicServiceHealthSummary {
  service_type: ServiceType;
  daily_metrics: PublicDailyServiceMetrics[];
  current_status: ServiceStatus;
}

export interface PublicEnvironmentHealthStatus {
  environment: string;
  environment_type: string;
  services: PublicServiceHealthSummary[];
  incidents: IncidentSummary[];
}

export interface ClientStatusPageResponse {
  client: string;
  client_description: string;
  generated_at: string;
  environments: PublicEnvironmentHealthStatus[];
}

// ===== Protected API Types (for internal DevOps dashboard) =====
export interface DailyServiceMetrics {
  date: string;
  uptime_percent: number;
  avg_response_time_ms: number | null;
  total_checks: number;
  successful_checks: number;
  status: ServiceStatus;
}

export interface ServiceHealthSummary {
  service_type: ServiceType;
  daily_metrics: DailyServiceMetrics[];
  overall_uptime_percent: number;
  current_status: ServiceStatus;
}

export interface EnvironmentHealthStatus {
  environment: string;
  environment_type: string;
  services: ServiceHealthSummary[];
  incidents: IncidentSummary[];
}

export interface ClientHealthSummary {
  client: string;
  client_description: string;
  overall_status: ServiceStatus;
  environments: EnvironmentHealthStatus[];
}

export interface AllClientsHealthResponse {
  generated_at: string;
  clients: ClientHealthSummary[];
}

// ===== Shared Types =====
export interface IncidentSummary {
  id: number;
  incident_type: IncidentType;
  title: string;
  description: string;
  status: IncidentStatus;
  start_time: string;
  end_time: string | null;
  is_global: boolean;
}
